import { MessageTemplate } from 'src/models/MessageTemplate'
import { spliceOne } from 'src/utils/array'
import useSWR, { mutate } from 'swr'
import { ApiClient } from './client'
import {
  GET_FIXED_MESSAGES,
  POST_FIXED_MESSAGES,
  putFixedMessages,
} from './endpoints'
import { MessageTemplateResponse } from './types/messageTemplate'

const toTemplate = (data: MessageTemplateResponse) => ({
  id: data.id,
  template: data.context,
})
const messageTemplateFetcher = async (url: string) => {
  const res = await ApiClient.get<MessageTemplateResponse[]>(url)
  if (res.error || !res.data) return []
  return res.data.map(toTemplate)
}

export const useMessageTemplates = () =>
  useSWR<MessageTemplate[]>(GET_FIXED_MESSAGES, messageTemplateFetcher)

export const addMessageTemplate = async (content: string) => {
  const res = await ApiClient.post(POST_FIXED_MESSAGES, {
    context: content,
  })
  if (res.error) return res
  mutate(
    GET_FIXED_MESSAGES,
    async (templates: MessageTemplate[]) => [
      ...templates,
      toTemplate(res.data),
    ],
    false,
  )
  return res
}

export const updateMessageTemplate = async (id: number, template: string) => {
  const res = await ApiClient.put(putFixedMessages(id), {
    context: template,
  })
  if (res.error) return res
  mutate(
    GET_FIXED_MESSAGES,
    async (templates: MessageTemplate[]) => {
      const index = templates.findIndex((each) => each.id === id)
      return spliceOne(templates, index, { template })
    },
    false,
  )
  return res
}
